<template>
  <div class="main-map-container">
    <div class="background-layer" id="domId">


    </div>
    <div class="content-layer">
      <!-- 顶部标题栏 -->
      <header class="header">
        <div class="header-mask"></div>
        <div class="grid-bg"></div>
        <div class="glow-border"></div>
        <div class="header-corner-line tl"></div>
        <div class="header-corner-line tr"></div>
        <div class="header-corner-line bl"></div>
        <div class="header-corner-line br"></div>
        <div class="header-title-line top"></div>
        <div class="header-title-line bottom"></div>
        <div class="header-bottom-line"></div>
        
        <div class="header-left">
          <div class="logo-section">
            <img class="logo-icon" src="./png/Logo.png" alt="Logo" style="height: 80px; width: 50px;" />
            <div class="logo-text">
              <img src="./png/LogoName.png" alt="Logo Name" style="width: 200px; height: 50px;" />
            </div>
            <div class="logo-particle p1"></div>
            <div class="logo-particle p2"></div>
            <div class="logo-particle p3"></div>
            <div class="logo-particle p4"></div>
          </div>
        </div>
        
        <div class="header-center">
          <h1 class="main-title" data-text="达川区2024年美丽乡村路建设项目一期">达川区2024年美丽乡村路建设项目一期</h1>
        </div>
        
        <div class="header-right">
          <div class="time-section">
            <span class="time-icon">🕐</span>
            <span class="time-value">{{ currentTime }}</span>
          </div>
          <div class="company-info">
            <span class="company-name">中国华西企业股份有限公司Bim中心制</span>
          </div>
          <div class="header-icons">
            <span class="icon-item">📡</span>
            <span class="icon-item">🔒</span>
          </div>
        </div>
      </header>
    </div>

    <!-- 左右两侧面板 -->
    <div class="map-panels">
      <aside class="left-panel">
        <div class="panel-card" style="width: 500px; height: 1100px;">
          <div class="card-header">
            <span class="card-icon">📋</span>
            <span class="card-title">项目信息</span>
            <div class="card-decoration"></div>
          </div>
          <div class="card-content project-info">
            <div class="particles"></div>
            
            <!-- 项目信息列表 -->
            <div class="info-section">
              <div class="info-item tech-item">
                <span class="info-icon">🏗️</span>
                <div class="info-content">
                  <span class="info-label">工程名称</span>
                  <span class="info-value tech-text">达川区2024年美丽乡村路建设项目一期</span>
                </div>
              </div>
              
              <div class="info-item tech-item">
                <span class="info-icon">📍</span>
                <div class="info-content">
                  <span class="info-label">地理位置</span>
                  <span class="info-value tech-text">四川省达州市达川区</span>
                </div>
              </div>
              
              <div class="info-item tech-item">
                <span class="info-icon">💰</span>
                <div class="info-content">
                  <span class="info-label">施工总价</span>
                  <span class="info-value tech-text highlight">3.1042亿元</span>
                </div>
              </div>
              
              <div class="info-item tech-item">
                <span class="info-icon">📅</span>
                <div class="info-content">
                  <span class="info-label">合同工期</span>
                  <span class="info-value tech-text">1080日历天</span>
                </div>
              </div>
              
              <div class="info-divider"></div>
              
              <div class="info-item tech-item">
                <span class="info-icon">👷</span>
                <div class="info-content">
                  <span class="info-label">施工单位</span>
                  <span class="info-value tech-text">中国华西企业股份有限公司</span>
                </div>
              </div>
              
              <div class="info-item tech-item">
                <span class="info-icon">📐</span>
                <div class="info-content">
                  <span class="info-label">监理单位</span>
                  <div class="info-value tech-text multi-line">
                    <span>中新凯瑞工程咨询有限公司</span>
                    <span>四川富源工程管理咨询有限公司</span>
                    <span>重庆凯宏工程咨询有限公司</span>
                  </div>
                </div>
              </div>
              
              <div class="info-item tech-item">
                <span class="info-icon">🎨</span>
                <div class="info-content">
                  <span class="info-label">设计单位</span>
                  <span class="info-value tech-text">中大设计集团有限公司</span>
                </div>
              </div>
              
              <div class="info-item tech-item">
                <span class="info-icon">🔍</span>
                <div class="info-content">
                  <span class="info-label">勘察单位</span>
                  <span class="info-value tech-text">皓筠工程设计有限公司</span>
                </div>
              </div>
              
              <div class="info-item tech-item">
                <span class="info-icon">🏢</span>
                <div class="info-content">
                  <span class="info-label">建设单位</span>
                  <span class="info-value tech-text">达州市达川区拓川实业有限公司</span>
                </div>
              </div>
              
              <div class="info-item tech-item project-intro">
                <span class="info-icon">📝</span>
                <div class="info-content">
                  <span class="info-label">项目介绍</span>
                  <span class="info-value tech-text intro-text">
                    本项目为达川区2024年美丽乡村路建设项目一期，总投资3.1042亿元，建设内容涵盖X173、C62、X163等多条乡村道路改造升级，全长约50公里。项目采用四级公路标准建设，设计时速30公里/小时，建设内容包括路基工程、路面工程、桥梁涵洞、交通安全设施等。项目建成后将显著改善区域交通条件，促进乡村振兴发展。
                  </span>
                </div>
              </div>
            </div>
            
            <!-- 动态装饰线 -->
            <div class="scan-line"></div>
          </div>
        </div>
      </aside>

      <aside class="right-panel">
        <div class="panel-card" style="width: 480px; height: 1100px;">
          <div class="card-header">
            <span class="card-icon">🛣️</span>
            <span class="card-title">路线列表</span>
            <div class="card-decoration"></div>
          </div>
          <div class="card-content road-list">
            <div class="particles"></div>
            
            <!-- 路段卡片列表 -->
            <div class="road-card" v-for="(road, index) in roadList" :key="index" @click="handleRoadClick(road)">
              <div class="road-img">
                <img :src="road.image" :alt="road.name" />
                <div class="status-indicator" :class="road.status"></div>
              </div>
              <div class="road-info">
                <span class="road-name">{{ road.name }}</span>
                <span class="road-content">{{ road.content }}</span>
                <span class="road-status" :class="road.status">{{ road.statusText }}</span>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MainMap',
  data() {
    
    return { currentTime: '',
         // 路段数据
      roadList: [
        {
          name: 'X173路',
          image: require('./png/效果图1.png'),
          status: 'green',
          statusText: '施工中',
          content: '连接陈家乡与渠县界，全长8.5公里',
          url: 'https://sznj.web.jet.work/#/MeiLiXiangCun/173',
          lat: 31.109424,
          lon: 107.501814,
          alt: 1,
          worldPosition:{x: -2175.05, y: -4691.91, z: 0},
          src: require('./png/173路牌.png'),
        },
        {
          name: 'C62路',
          image: require('./png/效果图2.png'),
          status: 'green',
          statusText: '施工中',
          content: '乡村旅游专线，串联多个景点',
          url: 'https://sznj.web.jet.work/#/MeiLiXiangCun/C62',
          worldPosition:{x: -2027.62, y: 9924.82, z: 0.1},
          src: require('./png/C62路牌.png'),
          lat: 31.109424,
          lon: 107.501814,
          alt: 1,
        },
        {
          name: 'C163路',
          image: require('./png/效果图3.png'),
          status: 'red',
          statusText: '未开始',
          content: '升级改造工程，提升通行能力',
          url: 'https://example.com/x163',
          worldPosition:{x: 9026.63, y: 584.16, z: 0},
          src: require('./png/C163路牌.png'),
          lat: 31.109424,
          lon: 107.501814,
          alt: 1,
        },
        {
          name: 'X171/X172路',
          image: require('./png/效果图4.png'),
          status: 'red',
          statusText: '未开始',
          content: '并行线路改造，优化交通网络',
          worldPosition:{x: -11975.33, y: 23548.88, z: 0},
          src: require('./png/X172路牌.png'),
          lat: 31.109424,
          lon: 107.501814,
          alt: 1,
        },
        {
          name: '石桥香隆公路',
          image: require('./png/效果图5.png'),
          status: 'red',
          statusText: '未开始',
          content: '石桥至香隆，助力乡村振兴',
          url: 'https://example.com/shiqiao-xianglong',
          worldPosition:{x: -14795.91, y: 17435.39, z: 0},
          src: require('./png/石桥镇至香隆农村路牌.png'),
          lat: 31.109424,
          lon: 107.501814,
          alt: 1,
        }
      ],
         //天地图相关
      viewer: null,
      app: null,
      // 声明 UI管理器、主工具条、图层管理器
      uiMng: null,
      mainToolbar: null,
      layerMng: null,
      // 声明外部构件图层，外部构件管理器
      extLayer: null,
      extMng: null,
      // 声明三维标签管理器对象
      marker3DContainer: null,
      // 球体场景的viewToken
      viewToken: '',
      loadSceneId: '3419547200496768',
      // 状态标志
      swipe: null,
      isLayerAdded: false,
      isAddItemActivated: false,
      // 按钮文字
      addMarkerBtnText: '点击添加标签',
     }
  },
  mounted() {
    this.updateTime()
    setInterval(this.updateTime, 1000)
  },
  methods: {
    updateTime() {
      const now = new Date()
      this.currentTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`
    },
    initSDK() {
      const BimfaceLoaderConfig = new window.BimfaceSDKLoaderConfig()
      BimfaceLoaderConfig.viewToken = this.viewToken
      window.BimfaceSDKLoader.load(BimfaceLoaderConfig, this.onSDKLoadSucceeded, this.onSDKLoadFailed)
    },

    // 资源加载成功的回调函数
    onSDKLoadSucceeded(viewMetaData) {
      const dom4Show = document.getElementById('domId')
      const webAppConfig = new window.Glodon.Bimface.Application.WebApplicationGISConfig()
      webAppConfig.domElement = dom4Show
      webAppConfig.disableMapOcclusion = true;
      this.app = new window.Glodon.Bimface.Application.WebApplicationGIS(webAppConfig)
      this.viewer = this.app.getViewer()
      this.viewer.addScene(this.viewToken)

      // 场景加载的监听事件
      this.viewer.addEventListener(
        window.Glodon.Bimface.Viewer.ViewerGISEvent.SceneAdded,
        this.onSceneAdded
      )

      // 图层加载的监听事件
      this.viewer.addEventListener(
        window.Glodon.Bimface.Viewer.ViewerGISEvent.LayerAdded,
        this.onLayerAdded
      )
    },

    // 场景加载完成
    onSceneAdded() {
      // 获取图层管理器
      this.layerMng = this.viewer.getLayerManager()
      // 获取UI管理器
      this.uiMng = this.app.getUIManager()
      // 获取主工具条
      this.mainToolbar = this.uiMng.getToolbar('MainToolbar')

      // 构造三维标签管理器
      const markerConfig = new window.Glodon.Bimface.Plugins.Marker3D.Marker3DContainerConfig()
      markerConfig.viewer = this.viewer
      this.marker3DContainer = new window.Glodon.Bimface.Plugins.Marker3D.Marker3DContainer(markerConfig)

      // 构造外部构件图层
      this.extLayer = new window.Glodon.Bimface.Layer.ExternalObjectLayer({
        id: 'ext',
        name: 'exename'
      })
      this.viewer.getLayerManager().addLayer(this.extLayer)
      // 获取外部构件图层对应的管理器对象
      this.extMng = this.layerMng.getLayer('ext').getExternalObjectManager()
     this.addMarker3D();
      // 场景加载完成后自动添加BIM模型
      //this.addBIMLayer()
      // 场景加载完成后自动添加三维标签
      
    },

    // 图层加载完成
    onLayerAdded(data) {
      if (data.layerId === 'layer-2517075049457408') {
        const bimLayer = this.layerMng.getLayer('layer-2517075049457408')
        this.viewer.getCamera().zoomToBoundingBox({
          boundingBox: bimLayer.getBoundingBox()
        })
      }
    },

    // 资源加载失败的回调函数
    onSDKLoadFailed(error) {
      console.error('SDK加载失败:', error)
    },

    // 相机视角定位
    setCameraStatus() {
      this.viewer.getCamera().setStatus({
        orientation: { pitch: -1.2425808580399136, yaw: 3.920252926403413, roll: 0 },
        position: { lat: 33.761973270228054, lon: 113.03169694448638, alt: 399.4244951931313 }
      })
    },



    // 添加三维标签
    addMarker3D() {
      // 检查必要条件
      if (!this.marker3DContainer) {
        console.error('marker3DContainer 未初始化')
        return
      }
      
      if (!this.roadList || this.roadList.length === 0) {
        console.error('roadList 为空或未定义')
        return
      }
      
      // 检查SDK是否加载
      if (!window.Glodon || !window.Glodon.Bimface.Plugins.Marker3D) {
        console.error('Marker3D SDK 未加载')
        return
      }
      
      this.roadList.forEach((road) => {
        try {
          // 检查road数据
          if (!road || !road.name || !road.image) {
            console.warn('路段数据不完整:', road)
            return
          }
          
          // 检查经纬度数据
          if (!road.lat || !road.lon) {
            console.warn('路段缺少经纬度数据:', road.name)
            return
          }
          
          const config = new window.Glodon.Bimface.Plugins.Marker3D.Marker3DConfig()
          config.tooltip = road.name + ' - ' + (road.statusText || '')
          config.src = road.src,
          config.worldPosition = road.worldPosition,
          config.name = road.name
          config.size = 130
          
          const marker3d = new window.Glodon.Bimface.Plugins.Marker3D.Marker3D(config)
          
          if (!marker3d) {
            console.error('创建 marker3d 失败:', road.name)
            return
          }
          
          const that = this
          marker3d.onClick(function () {
            console.log('点击了标签:', road.name)
            // 如果有URL则在新窗口打开
            if (road.url) {
              window.open(road.url, '_blank')
            }
            that.selectedSection = road
            that.showSectionDialog = true
          })
          
          this.marker3DContainer.addItem(marker3d)
          console.log('成功添加 marker3d:', road.name)
          
        } catch (error) {
          console.error('添加 marker3d 出错:', road.name, error)
        }
      })
    },

    // 路段卡片点击事件
    handleRoadClick(road) {
      console.log('点击了路段:', road.name)
      // 如果有URL则在新窗口打开
      if (road.url) {
        window.open(road.url, '_blank')
      }
      this.selectedSection = road
      this.showSectionDialog = true
    },

  },
  
  created() {
    this.$axios({
             url: this.apiurl +
                 "LightModel/LoadSceneId?SceneId=" + this.loadSceneId
         }).then((res) => {
             if (res.status == 200) {
                 this.viewToken = res.data;
                 console.log(res.data)
                 this.initSDK();
                
             }
         }, (err) => {
         });
     
  }
}
</script>

<style scoped>
@import './shared-styles.css';

/* 确保组件内样式优先级高于共享样式 */
.main-map-container .map-panels {
  position: absolute;
  top: 0px !important;
  left: -30px !important;
  right: 0 !important;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-left: 0;
  padding: 0;
  pointer-events: none;
}

.main-map-container .left-panel {
  pointer-events: auto;
  z-index: 10;
  margin-left: 20px;
}

.main-map-container .right-panel {
  pointer-events: auto;
  z-index: 10;
  margin-right: 0;
  margin-left: auto;
  padding-right: 0;
}

/* 项目信息样式 */
.project-info {
  position: relative;
  padding: 15px;
}

.info-section {
  position: relative;
  z-index: 2;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 200, 180, 0.1);
  transition: all 0.3s ease;
}

.info-item:hover {
  background: rgba(0, 200, 180, 0.05);
  padding-left: 8px;
  border-radius: 4px;
}

.info-icon {
  font-size: 18px;
  opacity: 0.8;
  animation: iconPulse 2s ease-in-out infinite;
}

.info-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-label {
  font-size: 18px;
  font-weight: bold;
  color: rgba(0, 200, 180, 0.8);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.info-value {
  font-size: 16px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
}

.tech-text {
  background: linear-gradient(90deg, rgba(0, 200, 180, 0.8) 0%, rgba(255, 255, 255, 1) 50%, rgba(0, 200, 180, 0.8) 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  text-shadow: 0 0 10px rgba(0, 200, 180, 0.5);
}

.tech-text.highlight {
  font-size: 22px;
  font-weight: bold;
  color: #00ffcc;
  text-shadow: 0 0 15px rgba(0, 255, 204, 0.8), 0 0 30px rgba(0, 255, 204, 0.4);
  animation: valueGlow 2s ease-in-out infinite;
}

.multi-line {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 16px;
  font-weight: bold;
}

.info-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(0, 200, 180, 0.5) 50%, transparent 100%);
  margin: 15px 0;
  position: relative;
}

.info-divider::before {
  content: '';
  position: absolute;
  top: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 4px;
  background: rgba(0, 200, 180, 0.8);
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(0, 200, 180, 0.6);
}

/* 扫描线效果 */
.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent 0%, rgba(0, 200, 180, 0.8) 50%, transparent 100%);
  box-shadow: 0 0 10px rgba(0, 200, 180, 0.6);
  animation: scanMove 4s linear infinite;
  z-index: 1;
}

@keyframes iconPulse {
  0%, 100% { opacity: 0.8; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.1); }
}

@keyframes valueGlow {
  0%, 100% {
    text-shadow: 0 0 15px rgba(0, 255, 204, 0.8), 0 0 30px rgba(0, 255, 204, 0.4);
  }
  50% {
    text-shadow: 0 0 25px rgba(0, 255, 204, 1), 0 0 50px rgba(0, 255, 204, 0.6);
  }
}

@keyframes scanMove {
  0% { transform: translateY(0); opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { transform: translateY(760px); opacity: 0; }
}

/* 路段列表样式 */
.road-list {
  position: relative;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.road-card {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background: rgba(0, 200, 180, 0.05);
  border-radius: 10px;
  border: 2px solid rgba(0, 200, 180, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
  height: 160px;
}

.road-card:hover {
  background: rgba(0, 200, 180, 0.1);
  border-color: rgba(0, 200, 180, 0.4);
  transform: translateX(5px);
  box-shadow: 0 0 15px rgba(0, 200, 180, 0.3);
}

.road-img {
  position: relative;
  width: 200px;
  height: 140px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid rgba(0, 200, 180, 0.4);
  background: rgba(0, 200, 180, 0.1);
  flex-shrink: 0;
}

.road-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.status-indicator {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  animation: statusPulse 2s ease-in-out infinite;
}

.status-indicator.green {
  background: #00ff00;
  box-shadow: 0 0 8px rgba(0, 255, 0, 0.8);
}

.status-indicator.yellow {
  background: #ffff00;
  box-shadow: 0 0 8px rgba(255, 255, 0, 0.8);
}

.status-indicator.red {
  background: #ff0000;
  box-shadow: 0 0 8px rgba(255, 0, 0, 0.8);
}

.road-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.road-name {
  font-size: 20px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.9);
  background: linear-gradient(90deg, rgba(0, 200, 180, 0.8) 0%, rgba(255, 255, 255, 1) 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}

.road-content {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
  padding: 5px 0;
}

.road-status {
  font-size: 15px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 15px;
}

.road-status.green {
  background: rgba(0, 255, 0, 0.2);
  color: #00ff00;
  text-shadow: 0 0 8px rgba(0, 255, 0, 0.6);
}

.road-status.yellow {
  background: rgba(255, 255, 0, 0.2);
  color: #ffff00;
  text-shadow: 0 0 8px rgba(255, 255, 0, 0.6);
}

.road-status.red {
  background: rgba(255, 0, 0, 0.2);
  color: #ff0000;
  text-shadow: 0 0 8px rgba(255, 0, 0, 0.6);
}

@keyframes statusPulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.8; }
}
</style>